import React from 'react';
import { connect } from 'react-redux';
import { Button, Text, i18n, tokens } from '@simplybenefits/sb-ui-library';
import * as dates from '@simplybenefits/sb-dates';
import PhotoGrid from '../PhotoGrid';
import pdfReceiptImage from '../../../assets/pdf.png';

/**
 * 
 * @param {*} param0 
 * @returns 
 */
const ReviewClaim = (props) => {
    const { submitClaim } = props;

    const styles = {
        container: {
            display: 'flex',
            flex: 1,
            height: '100%',
            flexDirection: 'column',
            marginBottom: 5
        },
        details: {
            display: 'flex',
            flex: 1,
            overflow: 'auto',
            flexDirection: 'column',
            marginBottom: 20,
            paddingLeft: 10,
            paddingRight: 10
        },
        metaBlock: {
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'row',
            paddingBottom: 2
        },
        block: {
            paddingBottom: 10
        },
        receiptPhoto: {
            height: 200,
            width: 'auto',
            alignSelf: 'center',
            backgroundColor: 'transparent',
            marginTop: 10,
            display: 'block',
            margin: 'auto'
        }
    };

    return (
        <div style={ styles.container }>
            <div style={ styles.details }>
                <div style={ styles.metaBlock }>
                    <Text
                        light
                        mediumLarge
                        flex={1}
                    >
                        { i18n.t(tokens.labels.claims.patient) }:
                    </Text>

                    <Text mediumLarge>{ props.meta.patient }</Text>
                </div>

                <div style={ styles.metaBlock }>
                    <Text
                        light
                        mediumLarge
                        flex={1}
                    >
                        { i18n.t(tokens.labels.claims.category) }:
                    </Text>

                    <Text mediumLarge>{ props.meta.category }</Text>
                </div>

                <div style={ styles.metaBlock }>
                    <Text
                        light
                        mediumLarge
                        flex={1}
                    >
                        { i18n.t(tokens.labels.claims.service) }:
                    </Text>

                    <Text mediumLarge>{ props.meta.service }</Text>
                </div>

                <div style={ styles.metaBlock }>
                    <Text
                        light
                        mediumLarge
                        flex={1}
                    >
                        { i18n.t(tokens.labels.claims.serviceDate) }:
                    </Text>

                    <Text mediumLarge>{ dates.getLocalDisplay(props.meta.serviceDate) }</Text>
                </div>

                {
                    props.meta.serviceLength ?
                        <div style={ styles.metaBlock }>
                            <Text
                                light
                                mediumLarge
                                flex={1}
                            >
                                { i18n.t(tokens.labels.claims.serviceLength) }:
                            </Text>

                            <Text mediumLarge>{ `${ props.meta.serviceLength } min` }</Text>
                        </div>
                        :
                        null
                }

                {
                    props.meta.provider &&
                            <div style={ styles.metaBlock }>
                                <Text
                                    light
                                    mediumLarge
                                    flex={1}
                                >
                                    { i18n.t(tokens.labels.claims.clinic) }:
                                </Text>

                                <Text mediumLarge>{ props.meta.provider }</Text>
                            </div>
                }

                <div style={ styles.metaBlock }>
                    <Text
                        light
                        mediumLarge
                        flex={1}
                    >
                        { i18n.t(tokens.labels.claims.amount) }:
                    </Text>

                    <Text mediumLarge>${ props.meta.amountSubmitted }</Text>
                </div>

                <div style={ styles.block }>
                    <Text
                        light
                        mediumLarge
                        display="block"
                        customStyle={{ paddingBottom: 10 }}
                    >
                        { i18n.t(tokens.labels.claims.receiptInvoice) }:
                    </Text>

                    {
                        props.receiptPhoto.file.type === 'application/pdf' ?
                            <img alt="Receipt" src={ pdfReceiptImage } style={ styles.receiptPhoto } />
                            :
                            <img alt="Receipt" src={ props.receiptPhoto.image } style={ styles.receiptPhoto } />
                    }

                </div>

                <div style={ styles.block }>
                    <Text
                        light
                        mediumLarge
                        marginBottom={ 5 }
                        display="block"
                    >
                        { i18n.t(tokens.labels.claims.supportingDocuments) }:
                    </Text>

                    {
                        props.supportingPhotos && props.supportingPhotos.length > 0 ?
                            <PhotoGrid
                                photos={ props.supportingPhotos }
                            />
                            :
                            <Text
                                light
                                small
                            >
                                { i18n.t(tokens.labels.claims.noSupportingDocuments) }
                            </Text>
                    }
                </div>
            </div>

            <Text light tiny>
                { i18n.t(tokens.labels.claims.claimAgreementScreen2) }
            </Text>

            <Button
                onClick={ submitClaim }
                marginTop={ 2 }
                color="primary"
                fullWidth
                testid="submitclaimreview"
            >
                { i18n.t(tokens.buttons.submit) }
            </Button>
        </div>
    );
};

export default connect()(ReviewClaim);